module.exports = __webpack_public_path__ + "img/profitable-img-4.b0e677f2.png";